import { useRecoilValue } from 'recoil';
import { linkCasesMutationCountState } from 'domains/reporter/Reporter/state';

export const useIsLinkCasesMutating = (): boolean => {
  return useRecoilValue(linkCasesMutationCountState) > 0;
};
